/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" _stroke="#4A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" _stroke="#4A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
